import { formatarHoras } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { usePagamentoHorasOutletContext } from 'pages/PagamentoHoras.context'
import { useParams } from 'react-router-dom'
import {
    CreateOrUpdatePagamentoHorasSchema,
    CreatePagamentoHoras,
    pagamentoHoras,
} from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormPagamento from '../forms/FormPagamentoHoras'

export default function EditarPagamento() {
    const empresaId = useStore(state => state.companyId)
    const { mutateAsync, isLoading } = pagamentoHoras.mutations.useCreate({
        invalidateQuery: true,
    })

    const { funcionarioId } = useParams()
    const { data, competencia } = usePagamentoHorasOutletContext()

    const obj = data?.find(
        d => d.pagamento.funcionarioId === Number(funcionarioId),
    )

    if (!funcionarioId || !obj || !competencia) return null
    const { limite, pagamento } = obj

    const handleSubmit = (values: CreatePagamentoHoras) => {
        const regex = new RegExp('^([0-9]{1,3}):([0-5][0-9])$')

        if (!regex.test(values.horas) || !regex.test(values.faltas)) {
            toast.error('O valor deve ter o formato HHH:mm')
            return new Promise((_, reject) => reject())
        }

        return mutateAsync(
            {
                ...values,
                horas: formatarHoras(values.horas, 3),
                faltas: formatarHoras(values.faltas, 3),
                porcentagens: JSON.stringify(values.porcentagens),
                funcionarioId: Number(funcionarioId),
                empresaId,
                competencia,
            },
            {
                onSuccess: () => {
                    toast.success('Pagamento atualizado!')
                },
                onError: err => {
                    toast.error(err.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            loading={isLoading}
            onSubmit={v => handleSubmit(v)}
            schema={CreateOrUpdatePagamentoHorasSchema}
            defaultValues={{
                funcionarioId: Number(funcionarioId),
                empresaId,
                competencia,
                horas: formatarHoras(pagamento?.horas, 3),
                faltas: formatarHoras(pagamento?.faltas, 3),
                porcentagens: pagamento?.porcentagens ?? {},
            }}
            open={hasPermission(['update', 'PagamentoDeHoras'])}
        >
            <Dialog.Title>Gerenciar pagamento</Dialog.Title>
            <Dialog.Content>
                <FormPagamento limite={limite} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
